import type { CopyConfidence, CopyMethod } from '@2x3/shared';

/**
 * An unsaved copy, kept in this browser so a long transcription survives a
 * closed tab. Storage can be unavailable (private windows, blocked site data),
 * so every access is guarded and the page works without it.
 */
export interface Draft {
  transcript: string;
  noCw: boolean;
  method: CopyMethod;
  decoder: string;
  confidence: CopyConfidence;
  notes: string;
  savedAt: string;
}

const key = (clipId: string): string => `x3:draft:${clipId}`;

export function loadDraft(clipId: string): Draft | null {
  try {
    const raw = localStorage.getItem(key(clipId));
    return raw ? (JSON.parse(raw) as Draft) : null;
  } catch {
    return null;
  }
}

export function saveDraft(clipId: string, draft: Draft): void {
  try {
    localStorage.setItem(key(clipId), JSON.stringify(draft));
  } catch {
    // Out of quota or storage blocked: the draft is a convenience, not a record.
  }
}

export function clearDraft(clipId: string): void {
  try {
    localStorage.removeItem(key(clipId));
  } catch {
    // As above.
  }
}
